import { createUseStyles } from "react-jss";
const useStyles = createUseStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  containerSearch: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px 16px 32px",
    gap: "20px",
    width: "100%",
    maxWidth: "860px",
    "& > div": {
      width: "100%",
    },
  },
  divInput: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px 24px",
    width: "100%",
    "@media (max-width:899.95px)": {
      gridTemplateColumns: "1fr",
    },
    "& > *:last-child:nth-child(odd)": {
      gridColumn: "1 / -1",
    },
  },
});

export default useStyles;
